var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('Content',{staticClass:"resume-container",attrs:{"title":"期刊简介","item":_vm.resume}}),(_vm.resume.notice)?_c('Notice',{attrs:{"title":"征稿启事","noticeItem":_vm.resume}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }